import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';
import { TonChallengeStates } from '@/enums/apiEnums.ts';

export const containerStyle: CSSProperties = {
  marginTop: '10px',
  marginBottom: '10px',
  height: '50px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 5px'
};

export const leftContentStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flex: '1'
};

export const textContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: '12px'
};

export const titleStyle: CSSProperties = {
  margin: 0,
  padding: '0px 0px 1px',
  fontSize: '15px',
  fontWeight: 'bold',
  textAlign: 'left'
};

export const subtitleStyle: CSSProperties = {
  margin: 0,
  padding: '0px 0px',
  fontSize: '13px',
  fontFamily: UIConfig.Fonts.Primary,
  color: 'rgb(110, 110, 110)',
  textAlign: 'left'
};

export const buttonStyle = (state: TonChallengeStates): CSSProperties => ({
  background: '#000',
  opacity:
    state === TonChallengeStates.STATE_LOCKED ||
    state === TonChallengeStates.STATE_ARCHIVED
      ? 0.5
      : 1,
  borderRadius: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '94px',
  minHeight: '40px'
});

export const buttonTextStyle: CSSProperties = {
  fontSize: '13px',
  padding: '10px 18px',
  fontWeight: 'bold',
  color: '#FFF',
  fontFamily: UIConfig.Fonts.Primary
};

export const buttonContentStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const circleContainerStyle: CSSProperties = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  background: '#000',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0
};
